import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import {
  loadVenue,
  updateVenueSearchResults,
  resetVenueSearchResults,
  setIsNewVenue,
  setNewVenue,
  setVenueAsNoVenue,
  clearVenue,
} from 'actions/setupform'
import { getFeatureFlag } from 'selectors/settings'
import { getVenue } from 'selectors/entities'
import { getVenueSearchResults, isNewVenue } from 'selectors/setupform'
import Button from 'components/button'
import LoadingSpinner from 'components/loading-spinner'
import TextInput from 'components/setupform-form/field/text-input'
import VenueSearchNewInput from './venue-search-new-input'
import VenueSearchResults from './venue-search-results'
import VenueSearchGoogle from './venue-search-google'

import styles from './venue-search-container.css'

export class VenueSearchContainer extends Component {

  constructor(props) {
    super(props)

    this.updateVenueSearchResults = _.debounce(this.props.updateVenueSearchResults, 500)

    this.handleSearch = this.handleSearch.bind(this)
    this.handleSelectVenue = this.handleSelectVenue.bind(this)
    this.clearNewVenue = this.clearNewVenue.bind(this)
    this.handleSetNewVenue = this.handleSetNewVenue.bind(this)
    this.clearVenueSelection = this.clearVenueSelection.bind(this)
    this.handleSearchFocus = this.handleSearchFocus.bind(this)
    this.onNoVenueChange = this.onNoVenueChange.bind(this)
  }

  componentWillMount() {
    // TODO isNoVenueChecked should be based on the selected venue
    this.setState({ query: '', isNoVenueChecked: false })
  }

  onNoVenueChange(event) {
    this.setState({
      isNoVenueChecked: event.target.checked
    })
    if (event.target.checked) {
      this.setState({
        query: ''
      })
      this.props.setVenueAsNoVenue()
    } else {
      this.props.clearVenue()
    }
  }

  handleSearch(event) {
    this.props.resetVenueSearchResults()

    const query = event.target.value
    if (query) {
      this.updateVenueSearchResults(query)
      this.setState({ query })
    } else {
      this.setState({ query: '' })
    }
  }

  handleSearchFocus() {
    if (this.props.venueIdData.value) {
      this.clearVenueSelection()
    }
  }

  handleSelectVenue(venue) {
    this.props.venueIdData.onChange(venue.id)
    this.setState({ query: venue.name })
  }

  handleSetNewVenue() {
    this.clearVenueSelection()
    this.props.setIsNewVenue(true)
  }

  clearVenueSelection() {
    this.props.venueIdData.onChange(null)
    this.setState({ query: '' })
  }

  clearNewVenue() {
    this.props.venueNameData.onChange('')
    this.props.venueAddressData.onChange('')
    this.clearVenueSelection()
    this.props.setIsNewVenue(false)
    this.props.setNewVenue(null)
  }

  render() {
    // Render the new venue form if addNewVenue
    if (this.props.venueNameData.value || this.props.venueAddressData.value || this.props.addNewVenue) {
      if (this.props.newVenueCreation) {
        // New Google search add new venue
        return (
          <VenueSearchGoogle clearNewVenue={this.clearNewVenue} />
        )
      }
      // Old manual input add new venue
      return (
        <VenueSearchNewInput
          clearNewVenue={this.clearNewVenue}
          venueAddressData={this.props.venueAddressData}
          venueNameData={this.props.venueNameData}
        />
      )
    }

    // Render the search form with a possible results list
    const selectedVenueName = this.props.selectedVenue && this.props.selectedVenue.name
    return (
      <div styleName="search">
        <TextInput
          data={{
            onChange: this.handleSearch,
            onFocus: this.handleSearchFocus,
            value: this.props.venueIdData.value ? selectedVenueName : this.state.query,
          }}
          // fade the input if a venue is selected (can still focus input)
          faded={this.state.isNoVenueChecked || !!this.props.venueIdData.value}
          placeholder="Search..."
          disabled={this.state.isNoVenueChecked}
        />

        {(!this.props.venueIdData.value && this.state.query) &&
          <div>
            {this.props.results === null ? <LoadingSpinner /> :
            <div>
              <VenueSearchResults handleSelectVenue={this.handleSelectVenue} results={this.props.results} />
              <div styleName="add-new-button">
                <Button text="Can't find your venue?" type="utility" onClick={this.handleSetNewVenue} />
              </div>
            </div>
            }
          </div>
        }
        {this.props.allowNoVenue &&
          <label htmlFor="noVenue" styleName="labelled-checkbox">
            <input id="noVenue" type="checkbox" onChange={this.onNoVenueChange} checked={this.state.isNoVenueChecked} />
            {" "}
            No venue
          </label>
        }
      </div>
    )
  }

}

VenueSearchContainer.propTypes = {
  addNewVenue: PropTypes.bool,
  allowNoVenue: PropTypes.bool,
  newVenueCreation: PropTypes.bool,
  resetVenueSearchResults: PropTypes.func,
  results: PropTypes.array,
  selectedVenue: PropTypes.object,
  setIsNewVenue: PropTypes.func,
  setNewVenue: PropTypes.func,
  updateVenueSearchResults: PropTypes.func,
  venueAddressData: PropTypes.object,
  venueIdData: PropTypes.object,
  venueNameData: PropTypes.object,
  setVenueAsNoVenue: PropTypes.func,
  clearVenue: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => ({
  addNewVenue: isNewVenue(state),
  results: getVenueSearchResults(state),
  selectedVenue: getVenue(ownProps.venueIdData.value)(state),
  newVenueCreation: getFeatureFlag('portal_setupform_new_venue_creation')(state),
})

const mapDispatchToProps = {
  loadVenue,
  resetVenueSearchResults,
  setIsNewVenue,
  setNewVenue,
  updateVenueSearchResults,
  setVenueAsNoVenue,
  clearVenue
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(VenueSearchContainer, styles))



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/venue-search/venue-search-container.js
 **/